module.exports = __webpack_public_path__ + "img/4.915816e5.png";